export const ThemeType = {
  default: 'default',
} as const;

export type ThemeType = (typeof ThemeType)[keyof typeof ThemeType];
